import { Component, OnInit, OnDestroy, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { environment } from './../../../environments/environment';
import { AuthService } from '../../core/authentication/auth.service';
import { Subscription } from 'rxjs';
import { Profile } from 'selenium-webdriver/firefox';
import { Shell } from '../shell.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  name: string;
  role: string;
  isAdmin: boolean;
  isAuthenticated: boolean;
  subscription: Subscription;
  title: string;
  headerNotify: any;
  showPasswordExpiryWarning = false;
  passwordExpiryDays = 99;
  isUserMenuOpen = false;

  @Output() menuToggle = new EventEmitter<void>();

  constructor(public authService: AuthService, private service: Shell, private elementRef: ElementRef, private router: Router) { }

  ngOnInit() {
    this.subscription = this.authService.authNavStatus$.subscribe(status => this.isAuthenticated = status);
    this.name = this.authService.name;
    //this.role = this.authService.canalGroup;
    this.isAdmin = this.authService.isAdmin;
    this.title = environment.title;

    const daysRemaining = parseInt(this.authService.password_expiry_days_remaining, 10);

    if (daysRemaining <= 5) {
      this.showPasswordExpiryWarning = true;
      this.passwordExpiryDays = daysRemaining;
    }
  }

  login() {
    this.authService.login();
  }

  async signout() {
    this.closeUserMenu();

    // 1. Forzamos la navegación a la raíz primero (zona pública sin Guards)
    await this.router.navigate(['/']);

    // 2. Ahora que estamos en un lugar seguro, ejecutamos el flujo OIDC
    await this.authService.signout();
  }

  toggleUserMenu(event: Event) {
    event.stopPropagation();
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  closeUserMenu() {
    this.isUserMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.isUserMenuOpen) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains(event.target as Node);
    if (!clickedInside) {
      this.closeUserMenu();
    }
  }

  ngOnDestroy() {
    // prevent memory leak when component is destroyed
    this.subscription.unsubscribe();
  }

  redirectToChangePassword() {
    window.location.href = environment.authUrl + 'Identity/Account/ChangePassword'; // Ajusta la ruta según tu aplicación
  }

  toggleMenu() {
    this.menuToggle.emit();
  }

}
